import _regeneratorRuntime from "/nerv.app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/nerv.app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "/nerv.app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.json.stringify.js";
import noNetTip from "../components/NoNetTip";
import moment from 'moment';
import { getVipInfo, getVipFlag } from "@/utils/api";
import { createOrderApi } from "../../utils/api";
import { eventTracking, getActivityProducts } from "../../utils/native";
import { checkVersion, goToHcActivityVipPage, goToOpenVipPage } from "../../utils/utils";
export default {
  name: "advert",
  data: function data() {
    return {
      isloading: false,
      noNet: false,
      isiOS: sessionStorage.getItem("isiOS") === true || sessionStorage.getItem("isiOS") === 'true',
      vipTypeList: [],
      // 月、季、年会员卡片数据
      iosActivityList: [],
      // ios活动商品数据
      discountStartTime: "2024/07/04",
      // 折扣开始日期
      discountEndTime: "2024/07/18",
      // 折扣截止日期
      discountTip: "",
      // 折扣提示
      discountReason: "",
      // 特惠原因，如中秋特惠
      openPrice: "",
      oversea0: true,
      // 是否为国内版本，海外版取美元价格
      lang: navigator.language,
      // 系统语言
      type: 1,
      // 1-月度会员 2-季度会员 3-年度会员
      vipInfoList: [],
      flag: -1,
      date: null,
      discountTimer: null,
      discountFlag: 1,
      // flag: 1:活动未开始；2：活动进行中；3：活动已结束
      leftDay: '00',
      // 倒计时-天
      leftHour: '00',
      // 倒计时-小时
      leftMinute: '00',
      // 倒计时-分钟
      leftSeconds: '00' // 倒计时-秒

    };
  },
  components: {
    noNetTip: noNetTip
  },
  computed: {
    timeLeftText: function timeLeftText() {
      return this.discountFlag === 1 ? 'Start time' : this.discountFlag === 2 ? 'Ending time' : 'ended～';
    }
  },
  watch: {
    '$route.query': {
      handler: function handler(query) {
        if (query) {
          this.queryIsVip();
          console.log('isiOS', this.isiOS);

          if (this.isiOS && (this.isiOS === true || this.isiOS === 'true')) {
            this.initIosActivityList();
          } else {
            this.queryInfo();
          }
        }
      },
      immediate: true
    }
  },
  beforeCreate: function beforeCreate() {
    document.title = this.$t("message.vip.sleepVip"); // 标题国际化
  },
  created: function created() {
    this.oversea0 = process.env.VUE_APP_H5_ENV == 'vpa';

    if (this.isiOS && (this.isiOS === true || this.isiOS === 'true')) {
      console.log('created===> initIosActivityList');
      this.initIosActivityList();
    } else {
      this.initAndroidVipTypeList();
    } // 埋点


    eventTracking('sleep_activity_page', 'page_show');
  },
  mounted: function mounted() {
    var _this = this;

    this.discountTimer = setInterval(function () {
      _this.setDiscountTime();
    }, 1000);
  },
  beforeUnmount: function beforeUnmount() {
    if (this.discountTimer) {
      clearInterval(this.discountTimer);
      this.discountTimer = null;
    }
  },
  methods: {
    goToHcActivityVipPage: goToHcActivityVipPage,
    goToOpenVipPage: goToOpenVipPage,
    openVipPage: function openVipPage() {
      var showUpdateTips = checkVersion({
        wear3_android_oversea: '5.0.2'
      }, true);

      if (showUpdateTips) {
        this.$toast(this.$t('message.updateAppTips'));
      } else {
        this.goToOpenVipPage();
      }
    },
    // 设置折扣时间
    setDiscountTime: function setDiscountTime() {
      // 到时间之后限时折扣结束
      var start = moment.utc(this.discountStartTime + " 00:00:00");
      var end = moment.utc(this.discountEndTime + " 23:59:59");

      if (moment.utc().isBefore(start, 'second')) {
        //console.log('活动开始之前', moment().format('HH:mm:ss'))
        if (this.discountFlag !== 1) {
          this.discountFlag = 1;
        }

        var diff = moment(start).diff(moment.utc(), 'seconds');
        this.transferDiffTime(diff);
      } else if (moment.utc().isAfter(end, 'second')) {
        //console.log('活动结束之后', moment().format('HH:mm:ss'))
        if (this.discountFlag !== 3) {
          this.discountFlag = 3;
        }

        if (this.discountTimer) {
          clearInterval(this.discountTimer);
          this.discountTimer = null;
        }
      } else {
        //console.log('活动中', moment().format('HH:mm:ss'))
        if (this.discountFlag !== 2) {
          this.discountFlag = 2;
        }

        var _diff = moment(end).diff(moment.utc(), 'seconds');

        this.transferDiffTime(_diff);
      }
    },
    transferDiffTime: function transferDiffTime(diff) {
      var day = parseInt(diff / (24 * 60 * 60)) || 0;
      diff = diff - day * 24 * 60 * 60;
      var hour = parseInt(diff / (60 * 60)) || 0;
      diff = diff - hour * 60 * 60;
      var minute = parseInt(diff / 60) || 0;
      diff = diff - minute * 60;
      var seconds = parseInt(diff) || 0; //console.log(diff, day, '天', hour, '小时', minute, '分钟', seconds);

      this.leftDay = day < 10 ? "0".concat(day) : day;
      this.leftHour = hour < 10 ? "0".concat(hour) : hour;
      this.leftMinute = minute < 10 ? "0".concat(minute) : minute;
      this.leftSeconds = seconds < 10 ? "0".concat(seconds) : seconds;
    },
    // 初始化月度、季度、年度会员数据
    initAndroidVipTypeList: function initAndroidVipTypeList() {
      var oversea0 = this.oversea0;
      var priceUnit = oversea0 ? '￥' : '$';

      var _this$vipInfoList = _slicedToArray(this.vipInfoList, 3),
          _this$vipInfoList$ = _this$vipInfoList[0],
          info1 = _this$vipInfoList$ === void 0 ? {} : _this$vipInfoList$,
          _this$vipInfoList$2 = _this$vipInfoList[1],
          info2 = _this$vipInfoList$2 === void 0 ? {} : _this$vipInfoList$2,
          _this$vipInfoList$3 = _this$vipInfoList[2],
          info3 = _this$vipInfoList$3 === void 0 ? {} : _this$vipInfoList$3;

      var monthPrice = oversea0 ? info1.priceCny : info1.priceUsd || 0;
      var quartyPrice = oversea0 ? info2.priceCny : info2.priceUsd || 0;
      var yearPrice = oversea0 ? info3.priceCny : info3.priceUsd || 0;
      this.vipTypeList = [{
        id: 3,
        title: 'Annual',
        priceUnit: priceUnit,
        price: yearPrice,
        convert: this.$t("message.vip.priceEvery", {
          price: Number(yearPrice / 12).toFixed(2),
          oversea: oversea0 ? "" : "美",
          yuan: priceUnit
        }),
        origin: oversea0 ? 360 : 59.99,
        discount: '35% OFF',
        freeTitle: '年会员',
        freeDays: '30',
        topNumber: 200,
        describe: 'Plus 30-day membership'
      }, {
        id: 2,
        title: 'Quarterly',
        priceUnit: priceUnit,
        price: quartyPrice,
        convert: this.$t("message.vip.priceEvery", {
          price: Number(quartyPrice / 3).toFixed(2),
          oversea: oversea0 ? "" : "美",
          yuan: priceUnit
        }),
        origin: oversea0 ? 90 : 14.99,
        discount: '50% OFF',
        freeTitle: '季会员',
        freeDays: '15',
        topNumber: 200,
        describe: 'Plus 15-day membership'
      }, {
        id: 1,
        title: 'Monthly',
        priceUnit: priceUnit,
        convert: "",
        // 国内版显示 xx元/月
        price: monthPrice,
        origin: oversea0 ? 30 : 4.99,
        // 按月计算的原价
        discount: '',
        freeDays: '5',
        freeTitle: '月会员',
        topNumber: 200,
        describe: 'Plus 5-day membership'
      }];
    },
    queryInfo: function queryInfo() {
      var _this2 = this;

      this.isloading = true;
      getVipInfo().then(function (res) {
        // console.log('getVipInfo', res)
        _this2.isloading = false;
        _this2.vipInfoList = res;

        _this2.initAndroidVipTypeList();
      }).catch(function (err) {
        _this2.isloading = false;

        if (err.code === "ECONNABORTED") {
          _this2.noNet = true;
        }
      });
    },
    // 初始化ios商品数据信息
    initIosActivityList: function initIosActivityList() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var result;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                console.log('初始化ios商品数据信息');
                _context.next = 3;
                return getActivityProducts();

              case 3:
                result = _context.sent;
                console.log('获取到的ios result', result);

                if (result && result.length) {
                  _this3.iosActivityList = result.map(function (item) {
                    return Object.assign({}, item, {
                      isFirst: item.productID === "com.mobvoi.companion.at.hc.annually" || item.productID === "com.mobvoi.companion.hc.sleep.vip.annual.01"
                    });
                  });
                } else {
                  _this3.iosActivityList = [{
                    productID: "com.mobvoi.companion.at.hc.annually",
                    name: 'HC annual membership',
                    displayPrice: 'US$39.99',
                    discount: '50%',
                    isFirst: true
                  }, {
                    productID: "com.mobvoi.companion.at.hc.oneyear",
                    name: 'HC one year membership',
                    displayPrice: 'US$44.99',
                    discount: '50%',
                    isFirst: false
                  }, {
                    productID: "com.mobvoi.companion.hc.sleep.vip.annual.01",
                    name: 'Sleep annual membership',
                    displayPrice: 'US$17.99',
                    discount: '50%',
                    isFirst: true
                  }, {
                    productID: "com.mobvoi.companion.hc.sleep.vip.year01",
                    name: 'Sleep one year membership',
                    displayPrice: 'US$19.99',
                    discount: '50%',
                    isFirst: false
                  }];
                }

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    // 请求是否为会员
    queryIsVip: function queryIsVip() {
      var _this4 = this;

      getVipFlag().then(function (res) {
        // console.log('getVipFlag', res)
        _this4.flag = res.vipFlag;
        _this4.date = res.vaildDate;
      });
    },
    // 开通vip支付
    openVip: function openVip(type) {
      this.openPrice = this.vipTypeList.find(function (item) {
        return item.id === type;
      }).price;
      this.selectedInfo = this.vipInfoList[type - 1];
      console.log(this.openPrice, this.selectedInfo);
      var _this$selectedInfo = this.selectedInfo,
          id = _this$selectedInfo.id,
          appleProductIdCny = _this$selectedInfo.appleProductIdCny,
          appleProductIdUsd = _this$selectedInfo.appleProductIdUsd,
          googleProductId = _this$selectedInfo.googleProductId;
      var openPrice = this.openPrice;
      var vipFlag = this.flag;
      var productId = this.oversea0 ? appleProductIdCny : appleProductIdUsd;
      var isiOS = sessionStorage.getItem("isiOS"); // console.log( id, productId, vipFlag, openPrice, googleProductId)
      // 埋点 amount 记录金额，单位为分

      eventTracking('sleep_activity_page', 'app_vip_open_click', {
        amount: openPrice * 100
      }); // console.log(isiOS)

      if (isiOS && isiOS !== "false") {
        window.webkit.messageHandlers.openVip.postMessage({
          id: id,
          productId: productId,
          vipFlag: vipFlag,
          amount: openPrice
        });
      } else {
        var showUpdateTips = checkVersion({
          wear3_android_oversea: '5.0.2'
        }, true);

        if (showUpdateTips) {
          this.$toast(this.$t('message.updateAppTips'));
          return false;
        }

        var data = {
          "oversea": localStorage.getItem('oversea'),
          "platform": 2,
          "type": 2,
          "vipId": id
        }; // console.log(data)

        createOrderApi(data).then(function (res) {
          var params = JSON.stringify({
            mammonUrl: res.mammonUrl,
            orderNo: res.order.orderNo,
            productId: googleProductId,
            productType: 'inapp',
            orderPrice: openPrice
          });
          console.log("调用原生startPay方法 params", params);

          try {
            window.MobvoiJSBridge.startPay(params);
          } catch (err) {
            console.log('调用原生startPay方法 报错', err);
          }
        });
      }
    }
  }
};